/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable no-unexpected-multiline */
import { useState } from 'react'

import { useLoading } from 'hooks'
import jsPDF from 'jspdf'
import autoTable, { RowInput } from 'jspdf-autotable'
import { COLORS, FORMAT } from 'utils'

import {
  IHandlePrintEfetivosTerceirosPorContratoProps,
  IHandlePrintEfetivosTerceirosPorFornecedorProps,
  IHandlePrintHHTSalarioPorContrato,
  IHandlePrintHHTSalarioPorFornecedor,
  IHandleDocumentacaoMensalPendencia as IHandlePrintDocumentacaoMensalPendencia,
  IHandlePrintRelatorioDeAcessoFornecedor,
  IHandlePrintRelatorioDeAcessoContrato,
  IHandlePrintRelatorioCreProps,
  IHandlePrintEfetivoLogico,
  IHandlePrintConsolidacaoEfetivo,
  IRelatorioQuantidadeEfetivoContent,
  IHandlePrintRelatorioBloqueioProps
} from './types'
import { createLine } from './utils'
import FormatarNumeros from 'utils/formatNumbers'

interface ICollapse {
  collapse: any[] | null
  header: string[]
  body: any[]
}

interface ITable {
  title: string
  tipo: string
  header: string[]
  body: any[]
  foot?: any[]
}

interface IHandlePrintPdfProps {
  filename: string
  data?: ICollapse[]
}

interface IHandlePrintTableProps {
  filename: string
  data?: ITable
}

interface IUsePrintReturn {
  printing: boolean
  handlePrintTable: (_props: IHandlePrintTableProps) => void
  handlePrintEfetivosTerceirosPorContrato: (
    _props: IHandlePrintEfetivosTerceirosPorContratoProps
  ) => void
  handlePrintEfetivosTerceirosPorFornecedor: (
    _props: IHandlePrintEfetivosTerceirosPorFornecedorProps
  ) => void
  handlePrintHHTSalarioPorContrato: (
    _props: IHandlePrintHHTSalarioPorContrato
  ) => void
  handlePrintHHTSalarioPorFornecedor: (
    _props: IHandlePrintHHTSalarioPorFornecedor
  ) => void
  handlePrintDocumentacaoMensalPendencia: (
    _props: IHandlePrintDocumentacaoMensalPendencia
  ) => void
  handlePrintRelatorioDeAcessoPorFornecedor: (
    _props: IHandlePrintRelatorioDeAcessoFornecedor
  ) => void
  handlePrintRelatorioDeAcessoPorContrato: (
    _props: IHandlePrintRelatorioDeAcessoContrato
  ) => void
  handlePrintEfetivoLogico: (_props: IHandlePrintEfetivoLogico) => void
  handlePrintQuantidadeEfetivo: (
    _props: IHandlePrintConsolidacaoEfetivo
  ) => void
  handlePrintFolhaPagamento: (_props: IHandlePrintConsolidacaoEfetivo) => void
  handlePrintHntHe: (_props: IHandlePrintConsolidacaoEfetivo) => void
  handlePrintTurnOver: (_props: IHandlePrintConsolidacaoEfetivo) => void
  handlePrintAdesaoTotalizadas: (
    _props: IHandlePrintConsolidacaoEfetivo
  ) => void
  handlePrintRelatorioCre: (_props: IHandlePrintRelatorioCreProps) => void
  handlePrintRelatorioBloqueio: (
    _props: IHandlePrintRelatorioBloqueioProps
  ) => void
  handlePrintRelatorioFornecedorBloqueado: (
    _props: IHandlePrintRelatorioBloqueioProps
  ) => void
}

const FILL_COLOR = COLORS.tableColor
const TEXT_COLOR = COLORS.blueFonts

const setJustifyIfHE = (justify: string, he: string | number) => {
  if (!justify || justify == '') return justify
  if (he && he.toString() != "0") return justify;
  return "---"
}

const usePrint = (): IUsePrintReturn => {
  const { setLoading } = useLoading()

  const [printing, setPrinting] = useState<boolean>(false)

  const handlePrintTable = async (props: IHandlePrintTableProps) => {
    setLoading('loading')
    setPrinting(true)

    const doc = new jsPDF('landscape')

    autoTable(doc, {
      theme: 'grid',
      startY: 30,
      showHead: 'firstPage',
      showFoot: 'lastPage',
      bodyStyles: {
        valign: 'middle',
        halign: 'center',
        fontSize: 6,
      },
      footStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR,
        halign: 'center',
        fontSize: 6
      },
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR,
        valign: 'middle',
        halign: 'center'
      },
      didParseCell: (data) => {
        if (data.section === 'head') {
          // Apaga Celulas de preenchimento
          if (String(data.cell.raw) === '.') {
            data.cell.styles.textColor = FILL_COLOR
          }
        }

        if (data.section === 'foot') {
          data.cell.styles.fillColor = '#E5E4E4'
          data.cell.styles.textColor = COLORS.black
          data.cell.styles.fontSize = 12

          if (data.cell.raw === '.') {
            data.cell.styles.textColor = '#E5E4E4'
          }
        }
      },
      head: [
        [
          {
            content: `Tipo: ${props.data.tipo}`,
            colSpan: props.data.header.length,
            styles: { fillColor: '#FFF', fontSize: 10, textColor: '#000' }
          }
        ],
        createLine(props.data.header),
        [
          {
            content: props.data.title,
            colSpan: props.data.header.length,
            styles: { halign: 'center', fontSize: 14, fontStyle: 'bold' }
          }
        ],
        createLine(props.data.header),
        props.data.header
      ],
      body: props.data.body,
      foot: [
        createLine(props.data.header.splice(0, -1)),
        [
          {
            content: props.data.foot.join('   '),
            colSpan: props.data.header.length
          }
        ],
        createLine(props.data.header.splice(0, -1))
      ]
    })
    setPrinting(false)
    setLoading('idle')

    doc.save(`${props.filename}.pdf`)
  }

  const handlePrintEfetivosTerceirosPorContrato = async (
    props: IHandlePrintEfetivosTerceirosPorContratoProps
  ): Promise<void> => {
    return new Promise((resolve, reject) => {
      try {
        setLoading('loading')
        setTimeout(() => {
          try {
            setPrinting(true)

            const doc = new jsPDF('landscape')

            // PDF Title
            autoTable(doc, {
              theme: 'grid',
              bodyStyles: {
                fillColor: COLORS.primary,
                textColor: '#000'
              },
              headStyles: {
                fillColor: FILL_COLOR,
                textColor: TEXT_COLOR
              },
              head: [
                [
                  {
                    content: props.data.title,
                    colSpan: 14,
                    styles: {
                      fontStyle: 'bold',
                      textColor: TEXT_COLOR,
                      halign: 'center',
                      fontSize: 15
                    }
                  }
                ]
              ],
              body: [
                [
                  {
                    content: `Mês Inicial: ${props.data.mesInicial}`,
                    colSpan: 7,
                    styles: { fontStyle: 'bold', textColor: '#000', halign: 'center' }
                  },
                  {
                    content: `Mês Final: ${props.data.mesFinal}`,
                    colSpan: 7,
                    styles: { fontStyle: 'bold', textColor: '#000', halign: 'center' }
                  }
                ]
              ]
            })

            // PDF Content
            props.data.content.forEach((contract) => {
              autoTable(doc, {
                theme: 'grid',
                showHead: 'firstPage',
                showFoot: 'lastPage',
                headStyles: {
                  fillColor: FILL_COLOR,
                  textColor: '#000',
                  fontStyle: 'normal'
                },
                bodyStyles: {
                  halign: 'center'
                },
                footStyles: {
                  fillColor: COLORS.lightGray,
                  textColor: '#000',
                  fontStyle: 'normal',
                  halign: 'center'
                },
                didParseCell: (data) => {
                  if (data.section === 'head') {
                    if (data.row.index === 5) {
                      data.cell.styles.fillColor = FILL_COLOR
                      data.cell.styles.textColor = TEXT_COLOR
                      data.cell.styles.fontStyle = 'bold'
                      data.cell.styles.halign = 'center'
                      data.cell.styles.valign = 'middle'
                    }
                  }
                },
                head: [
                  [
                    { content: 'Contrato:', colSpan: 1, styles: { fontStyle: 'bold' } },
                    {
                      content: contract.cdContrato,
                      colSpan: 10,
                      styles: { textColor: TEXT_COLOR }
                    }
                  ],
                  [
                    {
                      content: 'Fornecedor:',
                      colSpan: 1,
                      styles: { fontStyle: 'bold' }
                    },
                    { content: contract.nmFornecedor, colSpan: 8 }
                  ],
                  [
                    { content: `DE: ${contract.de}`, colSpan: 4 },
                    { content: `DIR: ${contract.dir}`, colSpan: 5 }
                  ],
                  [
                    { content: `GG: ${contract.gg}`, colSpan: 4 },
                    { content: `GER: ${contract.ger}`, colSpan: 5 }
                  ],
                  [
                    {
                      content: 'MÃO DE OBRA',
                      colSpan: 14,
                      styles: {
                        fontStyle: 'bold',
                        fontSize: 12,
                        fillColor: '#FFF',
                        textColor: TEXT_COLOR,
                        halign: 'center'
                      }
                    }
                  ],
                  [
                    { content: 'Mês/Ano', colSpan: 1 },
                    { content: 'Status Movimentação', colSpan: 1 },
                    { content: 'Progresso do Fornecedor', colSpan: 1 },
                    { content: 'Ativo', colSpan: 1 },
                    { content: 'Demitido', colSpan: 1 },
                    { content: 'Acesso', colSpan: 1 },
                    { content: 'Transferido', colSpan: 1 },
                    { content: 'Afastado', colSpan: 1 },
                    { content: 'Compartilhado', colSpan: 1 },
                    { content: 'Total', colSpan: 1 },
                    { content: 'Sem Demitidos', colSpan: 1 }
                  ]
                ],
                body: contract.body,
                foot: [
                  [
                    { content: 'Total', colSpan: 3, styles: { fontStyle: 'bold' } },
                    ...contract.footer
                  ]
                ]
              })
            })

            // PDF Footer
            autoTable(doc, {
              theme: 'grid',
              bodyStyles: {
                fillColor: COLORS.lightGray,
                textColor: '#000',
                halign: 'center'
              },
              headStyles: {
                fillColor: FILL_COLOR,
                textColor: TEXT_COLOR,
                halign: 'center'
              },
              head: [
                [
                  '',
                  'Ativo',
                  'Demitido',
                  'Acesso',
                  'Transferido',
                  'Afastado',
                  'Compartilhado',
                  'Total',
                  'Sem demitidos'
                ]
              ],
              body: [
                [
                  {
                    content: 'Total Geral',
                    colSpan: 1,
                    styles: { fontStyle: 'bold', textColor: '#000', halign: 'center' }
                  },
                  ...props.data.totalGeral
                ]
              ]
            })
            doc.save(`${props.filename}.pdf`)
            setPrinting(false)
            setLoading('idle')
            resolve()
          } catch (error) {
            setPrinting(false)
            setLoading('idle')
            reject(error)
          }
        }, 100)
      } catch (error) {
        reject(error)
        setLoading('idle')
      }
    }
    )
  }

  const handlePrintEfetivosTerceirosPorFornecedor = (
    props: IHandlePrintEfetivosTerceirosPorFornecedorProps
  ) => {
    setLoading('loading')
    setPrinting(true)

    const doc = new jsPDF('landscape')

    // PDF Title
    autoTable(doc, {
      theme: 'grid',
      bodyStyles: {
        fillColor: COLORS.primary,
        textColor: '#000'
      },
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR
      },
      head: [
        [
          {
            content: props.data.title,
            colSpan: 14,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'center',
              fontSize: 15
            }
          }
        ]
      ],
      body: [
        [
          {
            content: `Mês Inicial: ${props.data.mesInicial}`,
            colSpan: 7,
            styles: { fontStyle: 'bold', textColor: '#000', halign: 'center' }
          },
          {
            content: `Mês Final: ${props.data.mesFinal}`,
            colSpan: 7,
            styles: { fontStyle: 'bold', textColor: '#000', halign: 'center' }
          }
        ]
      ]
    })

    // PDF Content
    props.data.content.forEach((contract) => {
      autoTable(doc, {
        theme: 'grid',
        showHead: 'firstPage',
        showFoot: 'lastPage',
        headStyles: {
          fillColor: FILL_COLOR,
          textColor: '#000',
          fontStyle: 'normal'
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 8,
          valign: 'middle'
        },
        footStyles: {
          fillColor: COLORS.lightGray,
          textColor: '#000',
          fontStyle: 'normal',
          halign: 'center'
        },
        didParseCell: (data) => {
          if (data.section === 'head') {
            if (data.row.index === 2) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }
          }
        },
        head: [
          [
            {
              content: 'Fornecedor:',
              colSpan: 2,
              styles: { fontStyle: 'bold' }
            },
            { content: contract.nmFornecedor, colSpan: 12 }
          ],
          [
            {
              content: 'MÃO DE OBRA',
              colSpan: 15,
              styles: {
                fillColor: '#FFF',
                fontStyle: 'bold',
                fontSize: 12,
                textColor: TEXT_COLOR,
                halign: 'center'
              }
            }
          ],
          [
            'Contrato',
            // 'Mês/Ano',
            'Status Movimentação',
            'DE',
            'DIR',
            'GG',
            'GER',
            'Ativo',
            'Demitido',
            'Acesso',
            'Transferido',
            'Afastado',
            'Compartilhado',
            'Total Efetivo | Sem Demitidos',
            'Contraparte'
          ]
        ],
        body: contract.body,
        foot: [
          [
            { content: 'Total', colSpan: 6, styles: { fontStyle: 'bold' } },
            ...contract.footer,
            ''
          ]
        ]
      })
    })

    // PDF Footer
    autoTable(doc, {
      theme: 'grid',
      bodyStyles: {
        fillColor: COLORS.lightGray,
        textColor: '#000',
        halign: 'center'
      },
      showHead: 'firstPage',
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR,
        halign: 'center'
      },
      head: [
        [
          '',
          'Ativo',
          'Demitido',
          'Acesso',
          'Transferido',
          'Afastado',
          'Compartilhado',
          'Total Efetivo | Sem Demitidos',
        ]
      ],
      body: [
        [
          {
            content: 'Total Geral',
            colSpan: 1,
            styles: { fontStyle: 'bold', textColor: '#000', halign: 'center' }
          },
          ...props.data.totalGeral
        ]
      ]
    })

    setLoading('idle')
    setPrinting(false)

    doc.save(`${props.filename}.pdf`)
  }

  const handlePrintHHTSalarioPorContrato = (
    props: IHandlePrintHHTSalarioPorContrato
  ) => {
    setLoading('loading')
    setTimeout(() => {
      setPrinting(true)

      const doc = new jsPDF('landscape')

      // PDF Title
      autoTable(doc, {
        theme: 'grid',
        bodyStyles: {
          fillColor: COLORS.primary,
          textColor: '#000'
        },
        headStyles: {
          fillColor: FILL_COLOR,
          textColor: TEXT_COLOR
        },
        head: [
          [
            {
              content: props.data.title,
              colSpan: 1,
              styles: {
                fontStyle: 'bold',
                textColor: TEXT_COLOR,
                halign: 'center',
                fontSize: 15
              }
            }
          ]
        ],
        body: [
          [
            {
              content: `HHT X SALÁRIO - ${props.data.mesInicial} - ${props.data.mesFinal}`,
              colSpan: 1,
              styles: { fontStyle: 'bold', textColor: '#000', halign: 'center' }
            }
          ]
        ]
      })

      // PDF Content
      props.data.content.forEach((contract) => {
        autoTable(doc, {
          theme: 'grid',
          showHead: 'firstPage',
          showFoot: 'lastPage',
          headStyles: {
            fillColor: FILL_COLOR,
            textColor: '#000',
            fontStyle: 'normal'
          },
          bodyStyles: {
            halign: 'center',
            valign: 'middle',
          },
          footStyles: {
            fillColor: '#FFF',
            textColor: '#000',
            fontStyle: 'normal'
          },
          didParseCell: (data) => {
            if (data.section === 'head') {
              if (data.row.index === 5) {
                data.cell.styles.fillColor = FILL_COLOR
                data.cell.styles.textColor = TEXT_COLOR
                data.cell.styles.fontStyle = 'bold'
                data.cell.styles.halign = 'center'
                data.cell.styles.valign = 'middle'
              }
            }

            if (data.section === 'body') {
              if (data.column.index === 5) {
                data.cell.styles.fillColor = '#D1E2EA'
                data.cell.styles.textColor = '#000'
                data.cell.styles.fontSize = 8
                data.cell.styles.minCellWidth = 50
                data.cell.styles.cellWidth = 50
              }
            }
          },
          head: [
            [
              { content: 'Contrato:', colSpan: 1, styles: { fontStyle: 'bold' } },
              {
                content: contract.cdContrato,
                colSpan: 8,
                styles: { textColor: TEXT_COLOR }
              }
            ],
            [
              {
                content: 'Fornecedor:',
                colSpan: 1,
                styles: { fontStyle: 'bold' }
              },
              { content: contract.nmFornecedor, colSpan: 8 }
            ],
            [
              { content: `DE: ${contract.de}`, colSpan: 4 },
              { content: `DIR: ${contract.dir}`, colSpan: 4 }
            ],
            [
              { content: `GG: ${contract.gg}`, colSpan: 4 },
              { content: `GER: ${contract.ger}`, colSpan: 4 }
            ],
            [{ content: '', colSpan: 10 }],
            [
              'Mês/Ano',
              'Contrato',
              'Qtd.HHT',
              'Qtd.HE',
              'HE%',
              'Justificativa HE%',
              'Salário Base',
              'Total Folha',
              'Efetivo'
            ]
          ],
          body: contract.body
            .map((itemOfTable) => [
              [
                { content: '', colSpan: 5 },
                `Justificativa Nº Efetivos: ${itemOfTable.JustificativaNºEfetivos}`,
                { content: '', colSpan: 3 }
              ],
              [
                itemOfTable.mesAno,
                itemOfTable.contrato,
                itemOfTable.qtdHHT,
                itemOfTable.qtdHE,
                itemOfTable['HE%'],
                `Justificativa %HE: ${setJustifyIfHE(itemOfTable['justificativaHE%'], itemOfTable.qtdHE)}`,
                FORMAT.currency(itemOfTable.salBaseTotal),
                FORMAT.currency(itemOfTable.folhaPgtoTotal),
                itemOfTable.qtTotalEfetivoSemDemitido
              ],
              [
                { content: '', colSpan: 5 },
                `Justificativa Vlr Contratada: ${itemOfTable.JustificativaVlrContratada}`,
                { content: '', colSpan: 3 }
              ],
              [{ content: '', colSpan: 9 }]
            ])
            .flat(),
          foot: [
            [
              {
                content: 'MÊS ANO ANTERIOR:',
                colSpan: 1,
                styles: { fontStyle: 'bold' }
              },
              {
                content: contract.footer.mesAnoAnterior.mesAno,
                colSpan: 3,
                styles: { textColor: TEXT_COLOR }
              },
              { content: 'MÊS/ANO:', colSpan: 1, styles: { fontStyle: 'bold' } },
              {
                content: contract.footer.mesAno.mesAno,
                colSpan: 3,
                styles: { textColor: TEXT_COLOR }
              }
            ],
            [
              {
                content: 'Total Salário Base:',
                colSpan: 1,
                styles: { fontStyle: 'bold' }
              },
              {
                content: FORMAT.currency(
                  contract.footer.mesAnoAnterior.totalSalarioBase
                ),
                colSpan: 3
              },
              {
                content: 'Total Salário Base:',
                colSpan: 1,
                styles: { fontStyle: 'bold' }
              },
              {
                content: FORMAT.currency(contract.footer.mesAno.totalSalarioBase),
                colSpan: 3
              }
            ],
            [
              {
                content: 'Total Folha:',
                colSpan: 1,
                styles: { fontStyle: 'bold' }
              },
              {
                content: FORMAT.currency(
                  contract.footer.mesAnoAnterior.totalFolha, 'currency'
                ),
                colSpan: 3
              },
              {
                content: 'Total Folha:',
                colSpan: 1,
                styles: { fontStyle: 'bold' }
              },
              {
                content: FORMAT.currency(contract.footer.mesAno.totalFolha),
                colSpan: 3
              }
            ],
            [
              {
                content: 'Total HHT:',
                colSpan: 1,
                styles: { fontStyle: 'bold' }
              },
              { content: formatarNumero(contract.footer.mesAnoAnterior.totalHHT), colSpan: 3 },
              {
                content: 'Total HHT:',
                colSpan: 1,
                styles: { fontStyle: 'bold' }
              },
              { content: formatarNumero(contract.footer.mesAno.totalHHT), colSpan: 3 }
            ],
            [
              { content: 'Total HE:', colSpan: 1, styles: { fontStyle: 'bold' } },
              { content: formatarNumero(contract.footer.mesAnoAnterior.totalHE), colSpan: 3 },
              { content: 'Total HE:', colSpan: 1, styles: { fontStyle: 'bold' } },
              { content: formatarNumero(contract.footer.mesAno.totalHE), colSpan: 3 }
            ],
            [
              {
                content: 'Total Efetivo:',
                colSpan: 1,
                styles: { fontStyle: 'bold' }
              },
              {
                content: formatarNumero(contract.footer.mesAnoAnterior.totalEfetivo),
                colSpan: 3
              },
              {
                content: 'Total Efetivo:',
                colSpan: 1,
                styles: { fontStyle: 'bold' }
              },
              { content: formatarNumero(contract.footer.mesAno.totalEfetivo), colSpan: 3 }
            ],
            [
              {
                content: '% HHT x HE:',
                colSpan: 1,
                styles: { fontStyle: 'bold' }
              },
              { content: contract.footer.mesAnoAnterior['%HHTxHE'], colSpan: 3 },
              {
                content: '% HHT x HE:',
                colSpan: 1,
                styles: { fontStyle: 'bold' }
              },
              { content: contract.footer.mesAno['%HHTxHE'], colSpan: 3 }
            ]
          ]
        })
      })

      // PDF Footer
      autoTable(doc, {
        bodyStyles: {
          fillColor: '#FFF',
          textColor: '#000',
          fontStyle: 'normal'
        },
        body: [
          [{ content: '', colSpan: 4 }],
          [
            { content: 'MÊS ANO ANTERIOR:', styles: { fontStyle: 'bold' } },
            {
              content: props.data.mesAnoAnterior.mesAno,
              styles: { textColor: TEXT_COLOR }
            },
            { content: 'MÊS/ANO:', styles: { fontStyle: 'bold' } },
            {
              content: props.data.mesAno.mesAno,
              styles: { textColor: TEXT_COLOR }
            }
          ],
          [
            { content: 'Total Salário Base:', styles: { fontStyle: 'bold' } },
            {
              content: FORMAT.currency(props.data.mesAnoAnterior.totalSalarioBase)
            },
            { content: 'Total Salário Base:', styles: { fontStyle: 'bold' } },
            { content: FORMAT.currency(props.data.mesAno.totalSalarioBase) }
          ],
          [
            { content: 'Total Folha:', styles: { fontStyle: 'bold' } },
            { content: FORMAT.currency(props.data.mesAnoAnterior.totalFolha) },
            { content: 'Total Folha:', styles: { fontStyle: 'bold' } },
            { content: FORMAT.currency(props.data.mesAno.totalFolha) }
          ],
          [
            { content: 'Total HHT:', styles: { fontStyle: 'bold' } },
            { content: formatarNumero(props.data.mesAnoAnterior.totalHHT) },
            { content: 'Total HHT:', styles: { fontStyle: 'bold' } },
            { content: formatarNumero(props.data.mesAno.totalHHT) }
          ],
          [
            { content: 'Total HE:', styles: { fontStyle: 'bold' } },
            { content: formatarNumero(props.data.mesAnoAnterior.totalHE) },
            { content: 'Total HE:', styles: { fontStyle: 'bold' } },
            { content: formatarNumero(props.data.mesAno.totalHE) }
          ],
          [
            { content: 'Total Efetivo:', styles: { fontStyle: 'bold' } },
            { content: formatarNumero(props.data.mesAnoAnterior.totalEfetivo) },
            { content: 'Total Efetivo:', styles: { fontStyle: 'bold' } },
            { content: formatarNumero(props.data.mesAno.totalEfetivo) }
          ],
          [
            { content: '% HHT x HE:', styles: { fontStyle: 'bold' } },
            { content: formatarNumero(props.data.mesAnoAnterior['%HHTxHE'] as number) },
            { content: '% HHT x HE:', styles: { fontStyle: 'bold' } },
            { content: formatarNumero(props.data.mesAno['%HHTxHE'] as number) }
          ]
        ]
      })

      setPrinting(false)
      setLoading('idle')
      doc.save(`${props.filename}.pdf`)
    }, 100)
  }

  const handlePrintHHTSalarioPorFornecedor = (
    props: IHandlePrintHHTSalarioPorFornecedor
  ) => {
    setLoading('loading')
    setPrinting(true)

    const doc = new jsPDF('landscape')

    // PDF Title
    autoTable(doc, {
      theme: 'grid',
      bodyStyles: {
        fillColor: COLORS.primary,
        textColor: '#000'
      },
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR
      },
      head: [
        [
          {
            content: props.data.title,
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'center',
              fontSize: 15
            }
          }
        ]
      ],
      body: [
        [
          {
            content: `HHT X SALÁRIO - ${props.data.mesInicial} - ${props.data.mesFinal}`,
            colSpan: 1,
            styles: { fontStyle: 'bold', textColor: '#000', halign: 'center' }
          }
        ]
      ]
    })

    // PDF Content
    props.data.content.forEach((contract) => {
      autoTable(doc, {
        theme: 'grid',
        showHead: 'firstPage',
        showFoot: 'lastPage',
        headStyles: {
          fillColor: FILL_COLOR,
          textColor: '#000',
          fontStyle: 'normal'
        },
        bodyStyles: {
          halign: 'center',
          valign: 'middle',
          fontSize: 8
        },
        footStyles: {
          fillColor: '#FFF',
          textColor: '#000',
          fontStyle: 'normal'
        },
        didParseCell: (data) => {
          if (data.section === 'head') {
            if (data.row.index === 2) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }
          }

          if (data.section === 'body') {
            if (data.column.index === 8) {
              data.cell.styles.fillColor = '#D1E2EA'
              data.cell.styles.textColor = '#000'
              data.cell.styles.minCellWidth = 50
              data.cell.styles.cellWidth = 50
            }
          }
        },
        head: [
          [
            {
              content: 'Fornecedor:',
              colSpan: 1,
              styles: { fontStyle: 'bold' }
            },
            { content: contract.nmFornecedor, colSpan: 11 }
          ],
          [{ content: '', colSpan: 12 }],
          [
            'Contrato',
            'DE',
            'DIR',
            'GG',
            'GER',
            'Qtd.HHT',
            'Qtd.HE',
            'HE%',
            'Justificativa HE%',
            'Salário Base',
            'Total Folha',
            'Total Efetivo | Sem demitidos'
          ]
        ],
        body: contract.body
          .map((itemOfTable) => [
            [
              { content: '', colSpan: 8 },
              `Justificativa Nº Efetivos: ${itemOfTable.JustificativaNºEfetivos}`,
              { content: '', colSpan: 3 }
            ],
            [
              itemOfTable.cdContrato,
              itemOfTable.de,
              itemOfTable.dir,
              itemOfTable.gg,
              itemOfTable.ger,
              formatarNumero(itemOfTable.qtdHHT as unknown as number),
              formatarNumero(itemOfTable.qtdHE as unknown as number),
              formatarNumero(itemOfTable['HE%'] as unknown as number),
              `Justificativa %HE: ${setJustifyIfHE(itemOfTable['justificativaHE%'], itemOfTable.qtdHE)}`,
              FORMAT.currency(itemOfTable.salBaseTotal, 'currency'),
              FORMAT.currency(itemOfTable.folhaPgtoTotal, 'currency'),
              `${formatarNumero(itemOfTable.qtTotalEfetivoSemDemitido as unknown as number)} - ${formatarNumero(itemOfTable.qtTotalEfetivoComDemitido as unknown as number)}`
            ],
            [
              { content: '', colSpan: 8 },
              `Justificativa Vlr Contratada: ${itemOfTable.JustificativaVlrContratada}`,
              { content: '', colSpan: 3 }
            ],
            [{ content: '', colSpan: 12 }]
          ])
          .flat(),
        foot: [
          [
            {
              content: 'MÊS ANO ANTERIOR:',
              colSpan: 3,
              styles: { fontStyle: 'bold' }
            },
            {
              content: contract.footer.mesAnoAnterior.mesAno,
              colSpan: 3,
              styles: { textColor: TEXT_COLOR }
            },
            { content: 'MÊS/ANO:', colSpan: 3, styles: { fontStyle: 'bold' } },
            {
              content: contract.footer.mesAno.mesAno,
              colSpan: 3,
              styles: { textColor: TEXT_COLOR }
            }
          ],
          [
            {
              content: 'Total Salário Base:',
              colSpan: 3,
              styles: { fontStyle: 'bold' }
            },
            {
              content: FORMAT.currency(
                contract.footer.mesAnoAnterior.totalSalarioBase
              ),
              colSpan: 3
            },
            {
              content: 'Total Salário Base:',
              colSpan: 3,
              styles: { fontStyle: 'bold' }
            },
            {
              content: FORMAT.currency(contract.footer.mesAno.totalSalarioBase),
              colSpan: 3
            }
          ],
          [
            {
              content: 'Total Folha:',
              colSpan: 3,
              styles: { fontStyle: 'bold' }
            },
            {
              content: FORMAT.currency(
                contract.footer.mesAnoAnterior.totalFolha
              ),
              colSpan: 3
            },
            {
              content: 'Total Folha:',
              colSpan: 3,
              styles: { fontStyle: 'bold' }
            },
            {
              content: FORMAT.currency(contract.footer.mesAno.totalFolha),
              colSpan: 3
            }
          ],
          [
            {
              content: 'Total HHT:',
              colSpan: 3,
              styles: { fontStyle: 'bold' }
            },
            { content: contract.footer.mesAnoAnterior.totalHHT, colSpan: 3 },
            {
              content: 'Total HHT:',
              colSpan: 3,
              styles: { fontStyle: 'bold' }
            },
            { content: contract.footer.mesAno.totalHHT, colSpan: 3 }
          ],
          [
            { content: 'Total HE:', colSpan: 3, styles: { fontStyle: 'bold' } },
            { content: contract.footer.mesAnoAnterior.totalHE, colSpan: 3 },
            { content: 'Total HE:', colSpan: 3, styles: { fontStyle: 'bold' } },
            { content: contract.footer.mesAno.totalHE, colSpan: 3 }
          ],
          [
            {
              content: 'Total Efetivo:',
              colSpan: 3,
              styles: { fontStyle: 'bold' }
            },
            {
              content: contract.footer.mesAnoAnterior.totalEfetivo,
              colSpan: 3
            },
            {
              content: 'Total Efetivo:',
              colSpan: 3,
              styles: { fontStyle: 'bold' }
            },
            { content: contract.footer.mesAno.totalEfetivo, colSpan: 3 }
          ],
          [
            {
              content: '% HHT x HE:',
              colSpan: 3,
              styles: { fontStyle: 'bold' }
            },
            { content: contract.footer.mesAnoAnterior['%HHTxHE'], colSpan: 3 },
            {
              content: '% HHT x HE:',
              colSpan: 3,
              styles: { fontStyle: 'bold' }
            },
            { content: contract.footer.mesAno['%HHTxHE'], colSpan: 3 }
          ]
        ]
      })
    })

    // PDF Footer
    autoTable(doc, {
      bodyStyles: {
        fillColor: '#FFF',
        textColor: '#000',
        fontStyle: 'normal'
      },
      body: [
        [{ content: '', colSpan: 4 }],
        [
          { content: 'MÊS ANO ANTERIOR:', styles: { fontStyle: 'bold' } },
          {
            content: props.data.mesAnoAnterior.mesAno,
            styles: { textColor: TEXT_COLOR }
          },
          { content: 'MÊS/ANO:', styles: { fontStyle: 'bold' } },
          {
            content: props.data.mesAno.mesAno,
            styles: { textColor: TEXT_COLOR }
          }
        ],
        [
          { content: 'Total Salário Base:', styles: { fontStyle: 'bold' } },
          {
            content: FORMAT.currency(props.data.mesAnoAnterior.totalSalarioBase)
          },
          { content: 'Total Salário Base:', styles: { fontStyle: 'bold' } },
          { content: FORMAT.currency(props.data.mesAno.totalSalarioBase) }
        ],
        [
          { content: 'Total Folha:', styles: { fontStyle: 'bold' } },
          { content: FORMAT.currency(props.data.mesAnoAnterior.totalFolha) },
          { content: 'Total Folha:', styles: { fontStyle: 'bold' } },
          { content: FORMAT.currency(props.data.mesAno.totalFolha) }
        ],
        [
          { content: 'Total HHT:', styles: { fontStyle: 'bold' } },
          { content: props.data.mesAnoAnterior.totalHHT },
          { content: 'Total HHT:', styles: { fontStyle: 'bold' } },
          { content: props.data.mesAno.totalHHT }
        ],
        [
          { content: 'Total HE:', styles: { fontStyle: 'bold' } },
          { content: props.data.mesAnoAnterior.totalHE },
          { content: 'Total HE:', styles: { fontStyle: 'bold' } },
          { content: props.data.mesAno.totalHE }
        ],
        [
          { content: 'Total Efetivo:', styles: { fontStyle: 'bold' } },
          { content: props.data.mesAnoAnterior.totalEfetivo },
          { content: 'Total Efetivo:', styles: { fontStyle: 'bold' } },
          { content: props.data.mesAno.totalEfetivo }
        ],
        [
          { content: '% HHT x HE:', styles: { fontStyle: 'bold' } },
          { content: props.data.mesAnoAnterior['%HHTxHE'] },
          { content: '% HHT x HE:', styles: { fontStyle: 'bold' } },
          { content: props.data.mesAno['%HHTxHE'] }
        ]
      ]
    })

    setLoading('idle')
    setPrinting(false)

    doc.save(`${props.filename}.pdf`)
  }

  const handlePrintDocumentacaoMensalPendencia = (
    props: IHandlePrintDocumentacaoMensalPendencia
  ) => {
    setLoading('loading')
    setPrinting(true)

    const doc = new jsPDF('landscape')

    autoTable(doc, {
      theme: 'grid',
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR
      },
      head: [
        [
          {
            content: 'DOCUMENTAÇÃO MENSAL - PENDÊNCIA',
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'center',
              fontSize: 15
            }
          }
        ]
      ]
    })

    props.data.forEach((contract) => {
      autoTable(doc, {
        theme: 'grid',
        headStyles: {
          fillColor: FILL_COLOR,
          textColor: '#000'
        },
        bodyStyles: {
          valign: 'middle',
          halign: 'center'
        },
        didParseCell: (data) => {
          if (data.section === 'head') {
            if (data.row.index === 2) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }
          }
        },
        head: [
          [
            {
              content: contract.cdContrato,
              colSpan: 1,
              styles: { textColor: TEXT_COLOR, fontStyle: 'bold' }
            },
            {
              content: contract.empresa,
              colSpan: 5,
              styles: { fontStyle: 'bold' }
            },
            {
              content: 'Ini.',
              colSpan: 1,
              styles: {
                fontStyle: 'bold',
                textColor: TEXT_COLOR,
                halign: 'right'
              }
            },
            {
              content: FORMAT.formatDDMMYYYY(contract.dataIni),
              colSpan: 1,
              styles: { fontStyle: 'bold' }
            },
            {
              content: 'Fim.',
              colSpan: 1,
              styles: {
                fontStyle: 'bold',
                textColor: TEXT_COLOR,
                halign: 'right'
              }
            },
            {
              content: FORMAT.formatDDMMYYYY(contract.dataFim),
              colSpan: 1,
              styles: { fontStyle: 'bold' }
            }
          ],
          [
            {
              content: contract.titleCollapse,
              colSpan: 10,
              styles: { fontStyle: 'bold' }
            }
          ],
          [
            'Tipo Documento',
            'Contrato',
            'Competência',
            'Data Anexada',
            'Dias Pendentes',
            'Qtd.Analises',
            { content: 'Justificativa', colSpan: 2 },
            'Retorno Analise',
            'Status'
          ]
        ],
        body: contract.body
      })
    })

    setLoading('idle')
    setPrinting(false)

    doc.save(`${props.filename}.pdf`)
  }

  const handlePrintRelatorioDeAcessoPorFornecedor = (
    props: IHandlePrintRelatorioDeAcessoFornecedor
  ) => {
    setLoading('loading')
    setPrinting(true)

    const doc = new jsPDF('landscape')

    // PDF Title
    autoTable(doc, {
      theme: 'grid',
      bodyStyles: {
        fillColor: COLORS.primary,
        textColor: '#000',
        valign: 'middle',
        halign: 'center'
      },
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR,
        valign: 'middle',
        halign: 'center'
      },
      head: [
        [
          {
            content: props.title,
            colSpan: 2,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'center',
              fontSize: 15
            }
          }
        ]
      ],
      body: [
        [
          {
            content: `Mês Inicial: ${props.mesInicial}`,
            colSpan: 1,
            styles: { fontStyle: 'bold' }
          },
          {
            content: `Mês Final: ${props.mesFinal}`,
            colSpan: 1,
            styles: { fontStyle: 'bold' }
          }
        ]
      ]
    })

    // PDF Body
    props.data.forEach((contract) => {
      autoTable(doc, {
        theme: 'grid',
        showHead: 'firstPage',
        showFoot: 'lastPage',
        headStyles: {
          fillColor: FILL_COLOR,
          textColor: '#000',
          fontStyle: 'normal'
        },
        bodyStyles: {
          halign: 'center',
          valign: 'middle',
          fontSize: 8,
        },
        footStyles: {
          fillColor: COLORS.lightGray,
          textColor: '#000',
          fontStyle: 'normal',
          halign: 'center'
        },
        didParseCell: (data) => {
          if (data.section === 'head') {
            if (data.row.index === 1) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }
          }
        },
        head: [
          [
            {
              content: 'Fornecedor:',
              colSpan: 1,
              styles: { fontStyle: 'bold' }
            },
            { content: contract.nmFornecedor, colSpan: 11 }
          ],
          [
            'Contrato',
            'DE',
            'DIR',
            'GG',
            'GER',
            'CPF/Passaporte',
            'Colaborador',
            'Contato',
            'E-mail',
            'Vld. Acesso',
            'Perfil',
            'Status',
            // 'Contrato Atuação'
          ]
        ],
        body: contract.body
      })
    })
    setLoading('idle')
    setPrinting(false)

    doc.save(`${props.filename}.pdf`)
  }

  const handlePrintRelatorioDeAcessoPorContrato = (
    props: IHandlePrintRelatorioDeAcessoContrato
  ) => {
    setLoading('loading')
    setPrinting(false)

    const doc = new jsPDF('landscape')

    // PDF Title
    autoTable(doc, {
      theme: 'grid',
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR,
        valign: 'middle',
        halign: 'center'
      },
      head: [
        [
          {
            content: props.title,
            colSpan: 2,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'center',
              fontSize: 15
            }
          }
        ]
      ]
    })

    // PDF Body
    props.data.forEach((contract) => {
      autoTable(doc, {
        theme: 'grid',
        showHead: 'firstPage',
        headStyles: {
          fillColor: FILL_COLOR,
          textColor: '#000',
          fontStyle: 'normal'
        },
        bodyStyles: {
          valign: 'middle',
          halign: 'center'
        },
        didParseCell: (data) => {
          if (data.section === 'head') {
            if (data.row.index === 4) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }
          }
        },
        head: [
          [
            { content: 'Contrato:', colSpan: 1, styles: { fontStyle: 'bold' } },
            {
              content: contract.cdContrato,
              colSpan: 6,
              styles: { textColor: TEXT_COLOR }
            }
          ],
          [
            {
              content: 'Fornecedor:',
              colSpan: 1,
              styles: { fontStyle: 'bold' }
            },
            { content: contract.nmFornecedor, colSpan: 6 }
          ],
          [
            { content: `DE: ${contract.de}`, colSpan: 3 },
            { content: `DIR: ${contract.dir}`, colSpan: 3 }
          ],
          [
            { content: `GG: ${contract.gg}`, colSpan: 3 },
            { content: `GER: ${contract.ger}`, colSpan: 3 }
          ],
          [
            'Colaborador',
            'CPF/Passaporte',
            'Contato',
            'E-mail',
            'Vld.Acesse',
            'Perfil',
            'Status'
          ]
        ],
        body: contract.body
      })
    })

    setLoading('idle')
    setPrinting(false)

    doc.save(`${props.filename}.pdf`)
  }

  const handlePrintEfetivoLogico = (props: IHandlePrintEfetivoLogico) => {
    setLoading('loading')
    setPrinting(true)

    const doc = new jsPDF('landscape')

    autoTable(doc, {
      theme: 'grid',
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR
      },
      head: [
        [
          {
            content: 'RELATÓRIO - EFETIVO LÓGICO',
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'center',
              fontSize: 14
            }
          }
        ]
      ]
    })

    autoTable(doc, {
      theme: 'grid',
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: '#000'
      },
      bodyStyles: {
        valign: 'middle',
        halign: 'center'
      },
      didParseCell: (data) => {
        if (data.section === 'head') {
          if (data.row.index === 2) {
            data.cell.styles.fillColor = FILL_COLOR
            data.cell.styles.textColor = TEXT_COLOR
            data.cell.styles.fontStyle = 'bold'
            data.cell.styles.halign = 'center'
            data.cell.styles.valign = 'middle'
          }
        }
      },
      head: [
        [
          {
            content: props.data.cdContrato,
            colSpan: 1,
            styles: { textColor: TEXT_COLOR, fontStyle: 'bold' }
          },
          {
            content: props.data.empresa,
            colSpan: 2,
            styles: { fontStyle: 'bold' }
          },
          {
            content: 'Ini.',
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'right'
            }
          },
          {
            content: FORMAT.formatDDMMYYYY(props.data.dataIni),
            colSpan: 1,
            styles: { fontStyle: 'bold' }
          },
          {
            content: 'Fim.',
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'right'
            }
          },
          {
            content: FORMAT.formatDDMMYYYY(props.data.dataFim),
            colSpan: 1,
            styles: { fontStyle: 'bold' }
          }
        ],
        [
          {
            content: props.data.titleCollapse,
            colSpan: 7,
            styles: { fontStyle: 'bold' }
          }
        ],
        [
          'Nome',
          'CPF / Passaporte',
          'Data Nascimento',
          'Função',
          'Última Atualização',
          'Qtd. Dias',
          'Status'
        ]
      ],
      body: props.data.body
    })

    setLoading('idle')
    setPrinting(false)

    doc.save(`${props.filename}.pdf`)
  }

  const handlePrintQuantidadeEfetivo = (
    props: IHandlePrintConsolidacaoEfetivo
  ) => {
    setLoading('loading')
    setPrinting(true)

    const doc = new jsPDF('landscape')

    interface IColunaProps {
      content: string
      colSpan?: number
      styles: any
    }

    const colunasPDF: string[] = [
      '',
      'Dez',
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
      'Variação'
    ]
    const colunasArray: IColunaProps[] = []

    colunasPDF.forEach((colunaNome) => {
      colunasArray.push({
        content: colunaNome,
        colSpan: 1,
        styles: { fillColor: TEXT_COLOR }
      })
    })

    autoTable(doc, {
      theme: 'grid',
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR
      },
      head: [
        [
          {
            content: 'RELATÓRIO CONSOLIDAÇÃO - QUANTIDADE DE EFETIVO',
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'center',
              fontSize: 14
            }
          }
        ]
      ]
    })

    props.data.forEach((data: IRelatorioQuantidadeEfetivoContent) => {
      // Criação do novo Body contendo todas linhas/arrays
      const newRefactoredBody: RowInput[] = []

      data.body.map((body: RowInput[]) =>
        body.map((subItem: RowInput) => newRefactoredBody.push(subItem))
      )

      autoTable(doc, {
        theme: 'grid',
        headStyles: {
          fillColor: FILL_COLOR,
          textColor: '#000'
        },
        showHead: 'firstPage',
        showFoot: 'lastPage',
        bodyStyles: {
          valign: 'middle',
          halign: 'center'
        },
        didParseCell: (data) => {
          if (data.section === 'head') {
            if (data.row.index === 0) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.fontSize = 11
              data.cell.styles.halign = 'left'
              data.cell.styles.valign = 'middle'
            }
            if (data.row.index === 1) {
              data.cell.styles.fillColor = TEXT_COLOR
              data.cell.styles.textColor = 'white'
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }

            if (data.row.index === 2) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }
          }
        },
        head: [
          [
            {
              content: data.titleCollapse,
              colSpan: 15,
              styles: { fontStyle: 'bold' }
            }
          ],
          [
            {
              content: data.tableTitle,
              colSpan: 1
            },
            {
              content: data.anoAnterior,
              colSpan: 1,
              styles: { halign: 'center' }
            },
            {
              content: `Quantidade Efetivo ${data.anoAtual}`,
              colSpan: 13,
              styles: { halign: 'center' }
            }
          ],
          colunasArray
        ],
        body: newRefactoredBody
      })
    })

    setLoading('idle')
    setPrinting(false)

    doc.save(`${props.filename}.pdf`)
  }

  const handlePrintFolhaPagamento = (
    props: IHandlePrintConsolidacaoEfetivo
  ) => {
    setLoading('loading')
    setPrinting(true)

    const doc = new jsPDF('landscape')

    interface IColunaProps {
      content: string
      colSpan?: number
      styles: any
    }

    const colunasPDF: string[] = [
      '',
      'Dez',
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
      'Variação'
    ]
    const colunasArray: IColunaProps[] = []

    colunasPDF.forEach((colunaNome) => {
      colunasArray.push({
        content: colunaNome,
        colSpan: 1,
        styles: { fillColor: TEXT_COLOR }
      })
    })

    autoTable(doc, {
      theme: 'grid',
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR
      },
      head: [
        [
          {
            content: 'RELATÓRIO CONSOLIDAÇÃO - FOLHA DE PAGAMENTO',
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'center',
              fontSize: 14
            }
          }
        ]
      ]
    })

    props.data.forEach((data: IRelatorioQuantidadeEfetivoContent) => {
      // Criação do novo Body contendo todas linhas/arrays
      const newRefactoredBody: RowInput[] = []

      data.body.map((body: RowInput[]) =>
        body.map((subItem: RowInput) => newRefactoredBody.push(subItem))
      )

      autoTable(doc, {
        theme: 'grid',
        headStyles: {
          fillColor: FILL_COLOR,
          textColor: '#000'
        },
        showHead: 'firstPage',
        showFoot: 'lastPage',
        bodyStyles: {
          valign: 'middle',
          halign: 'center',
          fontSize: 8,
        },
        didParseCell: (data) => {
          if (data.section === 'body') {
            if (data.column.index === 0) {
              data.cell.styles.cellWidth = 35
              data.cell.styles.minCellWidth = 35
            }
          }
          if (data.section === 'head') {
            if (data.row.index === 0) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.fontSize = 11
              data.cell.styles.halign = 'left'
              data.cell.styles.valign = 'middle'
            }
            if (data.row.index === 1) {
              data.cell.styles.fillColor = TEXT_COLOR
              data.cell.styles.textColor = 'white'
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }

            if (data.row.index === 2) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }
          }
        },
        head: [
          [
            {
              content: data.titleCollapse,
              colSpan: 15,
              styles: { fontStyle: 'bold' }
            }
          ],
          [
            {
              content: data.tableTitle,
              colSpan: 1
            },
            {
              content: data.anoAnterior,
              colSpan: 1,
              styles: { halign: 'center' }
            },
            {
              content: `Folha Pagamento ${data.anoAtual}`,
              colSpan: 13,
              styles: { halign: 'center' }
            }
          ],
          colunasArray
        ],
        body: newRefactoredBody
      })
    })

    setLoading('idle')
    setPrinting(false)

    doc.save(`${props.filename}.pdf`)
  }

  const handlePrintHntHe = (props: IHandlePrintConsolidacaoEfetivo) => {
    setLoading('loading')
    setPrinting(true)

    const doc = new jsPDF('landscape')

    interface IColunaProps {
      content: string
      colSpan?: number
      styles: any
    }

    const colunasMesesPDF: string[] = [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez'
    ]

    const colunasPDF: string[] = [
      '',
      'HNT',
      'HE',
      'HNT',
      'HE',
      'HNT',
      'HE',
      'HNT',
      'HE',
      'HNT',
      'HE',
      'HNT',
      'HE',
      'HNT',
      'HE',
      'HNT',
      'HE',
      'HNT',
      'HE',
      'HNT',
      'HE',
      'HNT',
      'HE',
      'HNT',
      'HE'
    ]
    const colunasArray: IColunaProps[] = []
    const colunasMesesArray: IColunaProps[] = [
      { content: '', colSpan: 1, styles: { fillColor: TEXT_COLOR } }
    ]

    // Montando divisão das colunas

    colunasMesesPDF.forEach((colunaNome) => {
      colunasMesesArray.push({
        content: colunaNome,
        colSpan: 2,
        styles: { fillColor: TEXT_COLOR }
      })
    })

    colunasPDF.forEach((colunaNome) => {
      colunasArray.push({
        content: colunaNome,
        colSpan: 1,
        styles: { fillColor: TEXT_COLOR }
      })
    })

    //////
    autoTable(doc, {
      theme: 'grid',
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR
      },
      head: [
        [
          {
            content: 'RELATÓRIO CONSOLIDAÇÃO - HNT X HE',
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'center',
              fontSize: 14
            }
          }
        ]
      ]
    })

    props.data.forEach((data: IRelatorioQuantidadeEfetivoContent) => {
      // Criação do novo Body contendo todas linhas/arrays
      const newRefactoredBody: RowInput[] = []

      data.body.map((body: RowInput[]) =>
        body.map((subItem: RowInput) => newRefactoredBody.push(subItem))
      )

      autoTable(doc, {
        theme: 'grid',
        headStyles: {
          fillColor: FILL_COLOR,
          textColor: '#000'
        },
        showHead: 'firstPage',
        showFoot: 'lastPage',
        bodyStyles: {
          valign: 'middle',
          halign: 'center',
          fontSize: 4,
        },
        didParseCell: (data) => {
          if (data.section === 'body') {
            if (data.column.index === 0) {
              data.cell.styles.cellWidth = 35
              data.cell.styles.minCellWidth = 35
            }
          }

          if (data.section === 'head') {
            if (data.row.index === 0) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.fontSize = 11
              data.cell.styles.halign = 'left'
              data.cell.styles.valign = 'middle'
            }
            if (data.row.index === 1) {
              data.cell.styles.fillColor = TEXT_COLOR
              data.cell.styles.textColor = 'white'
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }

            if (data.row.index === 2) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.fontSize = 9
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }
            if (data.row.index === 3) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.fontSize = 8
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
              data.cell.styles.overflow = 'visible'
            }
          }
        },
        head: [
          [
            {
              content: data.titleCollapse,
              colSpan: 25,
              styles: { fontStyle: 'bold' }
            }
          ],
          [
            {
              content: data.tableTitle,
              colSpan: 1,
              styles: { minCellWidth: 'auto' }
            },
            {
              content: `HHT x HN ${data.anoAtual}`,
              colSpan: 24,
              styles: { halign: 'center' }
            }
          ],
          colunasMesesArray,
          colunasArray
        ],
        body: newRefactoredBody
      })
    })

    setLoading('idle')
    setPrinting(false)

    doc.save(`${props.filename}.pdf`)
  }

  const handlePrintTurnOver = (props: IHandlePrintConsolidacaoEfetivo) => {
    setLoading('loading')
    setPrinting(true)

    const doc = new jsPDF('landscape')

    interface IColunaProps {
      content: string
      colSpan?: number
      styles: any
    }

    const colunasPDF: string[] = [
      '',
      'Ativo',
      'Demitido',
      'Acesso',
      'Transferido',
      'Afastado',
      'Compartilhado',
      'Total',
      'Sem Demitidos',
      '% TurnOver'
    ]
    const colunasArray: IColunaProps[] = []

    colunasPDF.forEach((colunaNome) => {
      colunasArray.push({
        content: colunaNome,
        colSpan: 1,
        styles: { fillColor: TEXT_COLOR }
      })
    })

    autoTable(doc, {
      theme: 'grid',
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR
      },
      head: [
        [
          {
            content: 'RELATÓRIO CONSOLIDAÇÃO - TURN OVER',
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'center',
              fontSize: 14
            }
          }
        ]
      ]
    })

    props.data.forEach((data: IRelatorioQuantidadeEfetivoContent) => {
      // Criação do novo Body contendo todas linhas/arrays
      const newRefactoredBody: RowInput[] = []

      data.body.map((body: RowInput[]) =>
        body.map((subItem: RowInput) => newRefactoredBody.push(subItem))
      )

      autoTable(doc, {
        theme: 'grid',
        headStyles: {
          fillColor: FILL_COLOR,
          textColor: '#000'
        },
        showHead: 'firstPage',
        showFoot: 'lastPage',
        bodyStyles: {
          valign: 'middle',
          halign: 'center'
        },
        didParseCell: (data) => {
          if (data.section === 'head') {
            if (data.row.index === 0) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.fontSize = 11
              data.cell.styles.halign = 'left'
              data.cell.styles.valign = 'middle'
            }
            if (data.row.index === 1) {
              data.cell.styles.fillColor = TEXT_COLOR
              data.cell.styles.textColor = 'white'
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }

            if (data.row.index === 2) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }
          }
        },
        head: [
          [
            {
              content: data.titleCollapse,
              colSpan: 10,
              styles: { fontStyle: 'bold' }
            }
          ],
          [
            {
              content: data.tableTitle,
              colSpan: 1
            },
            {
              content: 'TURNOVER',
              colSpan: 9,
              styles: { halign: 'center' }
            }
          ],
          colunasArray
        ],
        body: newRefactoredBody
      })
    })

    setLoading('idle')
    setPrinting(false)

    doc.save(`${props.filename}.pdf`)
  }

  const handlePrintAdesaoTotalizadas = (
    props: IHandlePrintConsolidacaoEfetivo
  ) => {
    setLoading('loading')
    setPrinting(true)

    const doc = new jsPDF('landscape')

    interface IColunaProps {
      content: string
      colSpan?: number
      styles: any
    }

    const colunasPDF: string[] = [
      '',
      'Mobilizados no Mês',
      'Qtde de Fornecedor',
      'N° de Contratos',
      'N° de SubContratos',
      'Total (Contrato+Sub)',
      'Total de Contrapartes',
      'Contrapartes que Não Preencheram',
      'N° de Contrapartes(%)'
    ]
    const colunasArray: IColunaProps[] = []

    colunasPDF.forEach((colunaNome) => {
      colunasArray.push({
        content: colunaNome,
        colSpan: 1,
        styles: { fillColor: TEXT_COLOR }
      })
    })

    autoTable(doc, {
      theme: 'grid',
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR
      },
      head: [
        [
          {
            content: 'RELATÓRIO CONSOLIDAÇÃO - ADESÃO TOTALIZADAS',
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'center',
              fontSize: 14
            }
          }
        ]
      ]
    })

    props.data.forEach((data: IRelatorioQuantidadeEfetivoContent) => {
      // Criação do novo Body contendo todas linhas/arrays
      const newRefactoredBody: RowInput[] = []

      data.body.map((body: RowInput[]) =>
        body.map((subItem: RowInput) => newRefactoredBody.push(subItem))
      )

      autoTable(doc, {
        theme: 'grid',
        headStyles: {
          fillColor: FILL_COLOR,
          textColor: '#000'
        },
        showHead: 'firstPage',
        showFoot: 'lastPage',
        bodyStyles: {
          valign: 'middle',
          halign: 'center'
        },
        didParseCell: (data) => {
          if (data.section === 'head') {
            if (data.row.index === 0) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.fontSize = 11
              data.cell.styles.halign = 'left'
              data.cell.styles.valign = 'middle'
            }
            if (data.row.index === 1) {
              data.cell.styles.fillColor = TEXT_COLOR
              data.cell.styles.textColor = 'white'
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }

            if (data.row.index === 2) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }
          }
        },
        head: [
          [
            {
              content: data.titleCollapse,
              colSpan: 9,
              styles: { fontStyle: 'bold' }
            }
          ],
          [
            {
              content: data.tableTitle,
              colSpan: 1
            },
            {
              content: 'ADESÃO',
              colSpan: 8,
              styles: { halign: 'center' }
            }
          ],
          colunasArray
        ],
        body: newRefactoredBody
      })
    })

    setLoading('idle')
    setPrinting(false)

    doc.save(`${props.filename}.pdf`)
  }

  const handlePrintRelatorioCre = (props: IHandlePrintRelatorioCreProps) => {
    setLoading('loading')
    setPrinting(true)

    const doc = new jsPDF('landscape')

    // PDF Title
    autoTable(doc, {
      theme: 'grid',
      bodyStyles: {
        fillColor: COLORS.primary,
        textColor: '#000'
      },
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR
      },
      head: [
        [
          {
            content: props.data.title,
            colSpan: 6,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'center',
              fontSize: 15
            }
          }
        ]
      ],
      body: [
        [
          {
            content: props.data.subTitle,
            colSpan: 6,
            styles: { fontStyle: 'bold', textColor: '#000', halign: 'center' }
          }
        ]
      ]
    })

    // PDF Content
    props.data.content.forEach((contract) => {
      autoTable(doc, {
        theme: 'grid',
        showHead: 'firstPage',
        showFoot: 'lastPage',
        headStyles: {
          fillColor: FILL_COLOR,
          textColor: '#000',
          fontStyle: 'normal'
        },
        bodyStyles: {
          halign: 'center'
        },
        footStyles: {
          fillColor: COLORS.lightGray,
          textColor: '#000',
          fontStyle: 'normal',
          halign: 'center'
        },
        didParseCell: (data) => {
          if (data.section === 'head') {
            if (data.row.index === 7) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }
          }
        },
        head: [
          [
            {
              content: `Contrato: ${contract.cdContrato}`,
              colSpan: 7,
              styles: { fontStyle: 'bold', textColor: TEXT_COLOR }
            }
          ],
          [
            {
              content: `Fornecedor: ${contract.nmFornecedor}`,
              colSpan: 7,
              styles: { fontStyle: 'bold' }
            }
          ],
          [
            { content: `Início: ${contract.dtContratoIni}`, colSpan: 1 },
            { content: `Fim: ${contract.dtContratoFim}`, colSpan: 1 }
          ],
          [
            { content: `DE: ${contract.de}`, colSpan: 1 },
            { content: `DIR: ${contract.dir}`, colSpan: 4 }
          ],
          [
            { content: `CRE: ${contract.cdCRE}`, colSpan: 1 },
            // {
            //   content: `Data verificação: ${contract.dtVerificacao}`,
            //   colSpan: 1
            // },
            { content: `Entrada dia: ${contract.dtEntrada}`, colSpan: 1 },
            {
              content: `Retorno dia: ${contract.dtRetorno}`,
              colSpan: 1
            }
          ],
          [
            { content: `Analista: ${contract.nmAnalista}`, colSpan: 2 },
            { content: `Matrícula: ${contract.cdMatricula}`, colSpan: 1 },
            {
              content: `Qtd. Dias Bloqueio: ${contract.qtDiasBloqueio}`,
              colSpan: 1
            },
            { content: `Efetivo: ${contract.qtTotalEfetivos}`, colSpan: 1 }
          ],
          [
            {
              content: 'DESCRIÇÃO DAS PENDÊNCIAS',
              colSpan: 7,
              styles: {
                fontStyle: 'bold',
                fontSize: 12,
                fillColor: '#FFF',
                textColor: TEXT_COLOR,
                halign: 'center'
              }
            }
          ],
          [
            'Data Verif.',
            'Pendência',
            'Valor de Risco',
            'Descrição Pendência',
            'Qt Dias Criação Documento',
            'Data Lib.',
            'Matrícula Lib'
          ],
        ],
        body: contract.body
        // foot: [
        //   [
        //     { content: 'Total', colSpan: 2, styles: { fontStyle: 'bold' } },
        //     ...contract.footer
        //   ]
        // ]
      })
    })

    // PDF Totals
    autoTable(doc, {
      theme: 'grid',
      bodyStyles: {
        fillColor: COLORS.lightGray,
        textColor: '#000',
        halign: 'center'
      },
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR,
        halign: 'center'
      },
      head: [
        [
          {
            content: 'Total Pendências:',
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              fontSize: 12,
              fillColor: FILL_COLOR,
              textColor: TEXT_COLOR,
              halign: 'left'
            }
          },
          {
            content: 'Total  Risco:',
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              fontSize: 12,
              fillColor: FILL_COLOR,
              textColor: TEXT_COLOR,
              halign: 'left'
            }
          },
          {
            content: 'Total Risco Evitado:',
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              fontSize: 12,
              fillColor: FILL_COLOR,
              textColor: TEXT_COLOR,
              halign: 'left'
            }
          }
        ]
      ],
      body: [
        [
          {
            content: `Trabalhista: ${props.data.totalTrabalhista.qtPendencias}`,
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              fillColor: '#FFF',
              textColor: '#000',
              halign: 'left'
            }
          },
          {
            content: `Trabalhista: ${props.data.totalTrabalhista.vlRisco}`,
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              fillColor: '#FFF',
              textColor: '#000',
              halign: 'left'
            }
          },
          {
            content: `Trabalhista: ${props.data.totalTrabalhista.vlRiscoEvitado}`,
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              fillColor: '#FFF',
              textColor: '#000',
              halign: 'left'
            }
          }
        ],
        [
          {
            content: `Previdenciário: ${props.data.totalPrevidenciario.qtPendencias}`,
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              fillColor: '#FFF',
              textColor: '#000',
              halign: 'left'
            }
          },
          {
            content: `Previdenciário: ${props.data.totalPrevidenciario.vlRisco}`,
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              fillColor: '#FFF',
              textColor: '#000',
              halign: 'left'
            }
          },
          {
            content: `Previdenciário: ${props.data.totalPrevidenciario.vlRiscoEvitado}`,
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              fillColor: '#FFF',
              textColor: '#000',
              halign: 'left'
            }
          }
        ],
        [
          {
            content: `Outros: ${props.data.totalOutros.qtPendencias}`,
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              fillColor: '#FFF',
              textColor: '#000',
              halign: 'left'
            }
          },
          {
            content: `Outros: ${props.data.totalOutros.vlRisco}`,
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              fillColor: '#FFF',
              textColor: '#000',
              halign: 'left'
            }
          },
          {
            content: `Outros: ${props.data.totalOutros.vlRiscoEvitado}`,
            colSpan: 1,
            styles: {
              fontStyle: 'bold',
              fillColor: '#FFF',
              textColor: '#000',
              halign: 'left'
            }
          }
        ]
      ]
    })

    // PDF Footer
    autoTable(doc, {
      theme: 'grid',
      bodyStyles: {
        fillColor: COLORS.lightGray,
        textColor: '#000',
        halign: 'center'
      },
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR,
        halign: 'center'
      },
      head: [
        [
          'Total Geral Pendências',
          'Total Pendências Resolvidas',
          'Total Geral Risco R$',
          'Total Geral Riscos Evitados R$'
        ]
      ],
      body: [[...props.data.totalGeral]]
    })

    setLoading('idle')
    setPrinting(false)

    doc.save(`${props.filename}.pdf`)
  }

  // Relatório Bloqueio FR
  const handlePrintRelatorioBloqueio = (
    props: IHandlePrintRelatorioBloqueioProps
  ) => {
    setLoading('loading')
    setPrinting(true)

    const doc = new jsPDF('landscape')

    // PDF Title
    autoTable(doc, {
      theme: 'grid',
      bodyStyles: {
        fillColor: COLORS.primary,
        textColor: '#000'
      },
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR
      },
      head: [
        [
          {
            content: props.data.title,
            colSpan: 9,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'center',
              fontSize: 15
            }
          }
        ]
      ]
    })

    // PDF Content
    props.data.content.forEach((contract) => {
      autoTable(doc, {
        theme: 'grid',
        showHead: 'firstPage',
        showFoot: 'lastPage',
        headStyles: {
          fillColor: FILL_COLOR,
          textColor: '#000',
          fontStyle: 'normal'
        },
        bodyStyles: {
          halign: 'center'
        },
        footStyles: {
          fillColor: COLORS.lightGray,
          textColor: '#000',
          fontStyle: 'normal',
          halign: 'left'
        },
        didParseCell: (data) => {
          if (data.section === 'head') {
            if (data.row.index === 7) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }
          }
        },
        head: [
          [
            {
              content: `Contrato: ${contract.cdContrato}`,
              colSpan: 9,
              styles: { fontStyle: 'bold', textColor: TEXT_COLOR }
            }
          ],
          [
            {
              content: `Fornecedor: ${contract.nmFornecedor}`,
              colSpan: 9,
              styles: { fontStyle: 'bold' }
            }
          ],
          [
            {
              content: `Contraparte: ${contract.nmContraparte}`,
              colSpan: 7,
              styles: { fontStyle: 'bold' }
            },
            { content: `Data Emissão: ${contract.dataEmissao}`, colSpan: 2 }
          ],
          [
            { content: `DE: ${contract.de}`, colSpan: 4 },
            { content: `DIR: ${contract.dir}`, colSpan: 5 }
          ],
          [
            { content: `GG: ${contract.gg}`, colSpan: 4 },
            { content: `GER: ${contract.ger}`, colSpan: 5 }
          ],
          [
            {
              content: `Solicitante Bloqueio: ${contract.nmSolicitante}`,
              colSpan: 4
            },
            {
              content: `Motivo Bloqueio: ${contract.motivoBloqueio}`,
              colSpan: 3
            },
            {
              content: `Data Bloqueio: ${contract.dtBloqueio}`,
              colSpan: 2
            }
          ],
          [
            {
              content: '',
              colSpan: 9,
              styles: {
                fontStyle: 'bold',
                fontSize: 1,
                fillColor: '#FFF',
                textColor: TEXT_COLOR,
                halign: 'center'
              }
            }
          ],
          [
            'Contrato',
            'Nº Documento',
            'Tipo Documento',
            'Bloq Pgto',
            'Forma Pagto',
            'Descrição',
            'Valor Líquido',
            'Vencimento',
            'Folha Registro'
          ]
        ],
        body: contract.body,
        foot: [
          [
            {
              content: 'Observação de Risco:',
              colSpan: 2,
              styles: { fontStyle: 'bold', fontSize: 9 }
            }
          ],
          [
            {
              content: contract.observacao,
              colSpan: 9,
              styles: { fontSize: 10 }
            }
          ],
          [
            {
              content: 'Total de FR:',
              colSpan: 1,
              styles: { fontStyle: 'bold', fontSize: 9 }
            },
            {
              content: FORMAT.currency(contract.totalRisco),
              colSpan: 2
            },
            {
              content: 'Total de Risco sem FR:',
              colSpan: 1,
              styles: { fontStyle: 'bold', fontSize: 9 }
            },
            {
              content: FORMAT.currency(contract.totalRiscoSemFR),
              colSpan: 2
            },
            {
              content: 'Total Geral do Risco:',
              colSpan: 1,
              styles: { fontStyle: 'bold', fontSize: 9 }
            },
            {
              content: FORMAT.currency(contract.totalGeral),
              colSpan: 2
            }
          ]
        ]
      })
    })

    setLoading('idle')
    setPrinting(false)

    doc.save(`${props.filename}.pdf`)
  }

  // Relatório Fornecedor Bloqueado
  const handlePrintRelatorioFornecedorBloqueado = (
    props: IHandlePrintRelatorioBloqueioProps
  ) => {
    setLoading('loading')
    setPrinting(true)

    const doc = new jsPDF('landscape')

    // PDF Title
    autoTable(doc, {
      theme: 'grid',
      bodyStyles: {
        fillColor: COLORS.primary,
        textColor: '#000'
      },
      headStyles: {
        fillColor: FILL_COLOR,
        textColor: TEXT_COLOR
      },
      head: [
        [
          {
            content: props.data.title,
            colSpan: 6,
            styles: {
              fontStyle: 'bold',
              textColor: TEXT_COLOR,
              halign: 'center',
              fontSize: 15
            }
          }
        ]
      ]
    })

    // PDF Content
    props.data.content.forEach((contract) => {
      autoTable(doc, {
        theme: 'grid',
        showHead: 'firstPage',
        showFoot: 'lastPage',
        headStyles: {
          fillColor: FILL_COLOR,
          textColor: '#000',
          fontStyle: 'normal'
        },
        bodyStyles: {
          halign: 'center'
        },
        footStyles: {
          fillColor: COLORS.white,
          textColor: '#000',
          fontStyle: 'normal',
          halign: 'left'
        },
        didParseCell: (data) => {
          if (data.section === 'head') {
            if (data.row.index === 7) {
              data.cell.styles.fillColor = FILL_COLOR
              data.cell.styles.textColor = TEXT_COLOR
              data.cell.styles.fontStyle = 'bold'
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'middle'
            }
          }
        },
        head: [
          [
            {
              content: `Fornecedor: ${contract.nmFornecedor}`,
              colSpan: 6,
              styles: { fontStyle: 'bold' }
            }
          ],
          [
            {
              content: `Contraparte: ${contract.nmContraparte}`,
              colSpan: 5,
              styles: { fontStyle: 'bold' }
            },
            { content: `Data Emissão: ${contract.dataEmissao}`, colSpan: 1 }
          ],
          [
            { content: `DE: ${contract.de}`, colSpan: 3 },
            { content: `DIR: ${contract.dir}`, colSpan: 3 }
          ],
          [
            { content: `GG: ${contract.gg}`, colSpan: 3 },
            { content: `GER: ${contract.ger}`, colSpan: 3 }
          ],
          [
            {
              content: `Solicitante Bloqueio: ${contract.nmSolicitante}`,
              colSpan: 3
            },
            {
              content: `Motivo Bloqueio: ${contract.motivoBloqueio}`,
              colSpan: 2
            },
            {
              content: `Data Bloqueio: ${contract.dtBloqueio}`,
              colSpan: 1
            }
          ]
        ],
        //body: contract.body,
        foot: [
          [
            {
              content: 'Observação de Risco:',
              colSpan: 2,
              styles: { fontStyle: 'bold', fontSize: 9 }
            }
          ],
          [
            {
              content: contract.observacao,
              colSpan: 6,
              styles: { fontSize: 10 }
            }
          ],
          [
            {
              content: 'Total de FR:',
              colSpan: 1,
              styles: { fontStyle: 'bold', fontSize: 9 }
            },
            {
              content: FORMAT.currency(contract.totalRisco),
              colSpan: 1
            },
            {
              content: 'Total de Risco sem FR:',
              colSpan: 1,
              styles: { fontStyle: 'bold', fontSize: 9 }
            },
            {
              content: FORMAT.currency(contract.totalRiscoSemFR),
              colSpan: 1
            },
            {
              content: 'Total Geral do Risco:',
              colSpan: 1,
              styles: { fontStyle: 'bold', fontSize: 9 }
            },
            {
              content: FORMAT.currency(contract.totalGeral),
              colSpan: 1
            }
          ]
        ]
      })
    })

    setLoading('idle')
    setPrinting(false)

    doc.save(`${props.filename}.pdf`)
  }

  return {
    printing,
    handlePrintTable,
    handlePrintEfetivosTerceirosPorContrato,
    handlePrintEfetivosTerceirosPorFornecedor,
    handlePrintHHTSalarioPorContrato,
    handlePrintHHTSalarioPorFornecedor,
    handlePrintDocumentacaoMensalPendencia,
    handlePrintRelatorioDeAcessoPorFornecedor,
    handlePrintRelatorioDeAcessoPorContrato,
    handlePrintRelatorioCre,
    handlePrintEfetivoLogico,
    handlePrintQuantidadeEfetivo,
    handlePrintFolhaPagamento,
    handlePrintHntHe,
    handlePrintTurnOver,
    handlePrintAdesaoTotalizadas,
    handlePrintRelatorioBloqueio,
    handlePrintRelatorioFornecedorBloqueado
  }
}

function formatarNumero(numero: number) {
  return FormatarNumeros.formatarNumero(numero);
}

export default usePrint
